import PlaylistList from "../playlist-list";
import { PlaylistListPropsExtraOption, SortOptionValue } from "../playlist-list/view";
import { FunctionName, PaginatedResponse } from "../../../utils/apiTypes";
import { useCallback, useEffect, useRef, useState } from "react";
import { ArtistDTO } from "../../view/spotipitan/types";
import { Spotip17anFunctions } from "../../../utils/api";

type Props = {
    extraOptions?: PlaylistListPropsExtraOption[];
    functionName: FunctionName;
    functionCallProps?: Record<string, any>;
    onPlaylistClick?: (playlist: ArtistDTO) => void;
    searchQuery?: string;
}

const PaginatedPlaylistList = ({ extraOptions, functionCallProps, functionName, onPlaylistClick, searchQuery }: Props) => {

    const [playlists, setPlaylists] = useState<ArtistDTO[]>([]);
    const [loading, setLoading] = useState(false);
    const currentPage = useRef(0);
    const paginationInfo = useRef<PaginatedResponse<ArtistDTO>>();
    const fetchTimeout = useRef<NodeJS.Timeout | null>(null);
    const usedSort = useRef<SortOptionValue[]>([]);

    const fetchNewPage = useCallback(async (sort: SortOptionValue[]) => {

        if (loading && !fetchTimeout.current) return;

        setLoading(true);

        if (fetchTimeout.current) {
            clearTimeout(fetchTimeout.current);
        }

        fetchTimeout.current = setTimeout(() => {
            fetchTimeout.current = null;
            Spotip17anFunctions.use(functionName).call({ ...functionCallProps, sort, max: 15, page: currentPage.current })
                .then((res: PaginatedResponse<ArtistDTO>) => {
                    paginationInfo.current = res;
                    setPlaylists(prev => {
                        if (currentPage.current === 0) {
                            return res.data;
                        }
                        return [...prev, ...res.data];
                    });
                    usedSort.current = sort;
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }, 250);

    }, [functionName, functionCallProps, loading]);

    const fetchFirstPage = (sort: SortOptionValue[]) => {
        currentPage.current = 0;
        setPlaylists([]);
        fetchNewPage(sort);
        return true;
    };

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && paginationInfo.current && paginationInfo.current.hasNextPage && !fetchTimeout.current && !loading && usedSort.current) {
                    currentPage.current++;
                    fetchNewPage(usedSort.current);
                }
            });
        });

        const trigger = document.getElementById("next-page-trigger");
        if (trigger) {
            observer.observe(trigger);
        }
        return () => {
            if (trigger) {
                observer.unobserve(trigger);
            }
        };
    }, [fetchNewPage, loading]);

    return (
        <div className="playlist-list-container" style={{
            paddingBottom: "calc(60px + 3vw)",
        }}>
            <PlaylistList customSearchQuery={searchQuery} inputPlaylists={playlists} onPlaylistClick={onPlaylistClick} extraOptions={extraOptions}
                offlineMode={false} onChangeSort={fetchFirstPage} loading={loading} style={{
                    paddingBottom: "40px",
                }} />
            {!loading && <div id="next-page-trigger" style={{
                width: "100%",
                backgroundColor: "red"
            }}>
            </div>}
        </div>
    )

}

export default PaginatedPlaylistList;
